import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as e, jsxs as i, Fragment as f } from "react/jsx-runtime";
import v from "classnames";
import s from "../Typography/Typography.js";
import p from "../../assets/logo-mashvisor.svg.js";
import y from "../../assets/icons/facebook.svg.js";
import g from "../../assets/icons/twitter.svg.js";
import u from "../../assets/icons/linkedin.svg.js";
import b from "../../assets/icons/youtube.svg.js";
import N from "../../assets/icons/instagram.svg.js";
import t from "./Footer.module.scss.js";
import { getFooterLinks as w } from "./footerLinks.js";
var k = ( /* @__PURE__ */new Date()).getUTCFullYear(),
  L = function L(r) {
    return /* @__PURE__ */e("div", _objectSpread({
      className: t.col
    }, r));
  },
  c = function c(r) {
    return /* @__PURE__ */e(s, _objectSpread({
      variant: "body1",
      as: "h3",
      color: "#303030",
      className: t.title
    }, r));
  },
  a = function a(r) {
    return /* @__PURE__ */e(s, _objectSpread(_objectSpread({
      color: "#5E636B",
      variant: "body1",
      as: "a"
    }, r), {}, {
      className: v([t.link, r.className])
    }));
  },
  m = function m(r) {
    return /* @__PURE__ */e("ul", _objectSpread({
      className: t.ul
    }, r));
  },
  h = function h(r) {
    return /* @__PURE__ */e("li", _objectSpread({
      className: t.linkItem
    }, r));
  },
  B = function B(_ref) {
    var _ref$baseOrigin = _ref.baseOrigin,
      r = _ref$baseOrigin === void 0 ? "" : _ref$baseOrigin,
      _ref$version = _ref.version,
      n = _ref$version === void 0 ? "others" : _ref$version;
    var d = w({
      baseOrigin: r,
      version: n
    });
    return /* @__PURE__ */e("footer", {
      className: t.footer,
      children: /* @__PURE__ */i("div", {
        className: t.container,
        children: [/* @__PURE__ */e("div", {
          className: t.sectionsContainer,
          children: d.map(function (l) {
            return /* @__PURE__ */i(L, {
              children: [/* @__PURE__ */e(c, {
                children: l.columnName
              }), /* @__PURE__ */e(m, {
                children: l.links.map(function (o) {
                  return /* @__PURE__ */e(h, {
                    children: /* @__PURE__ */e(a, {
                      "aria-label": o.areaLabel,
                      href: o.href,
                      children: o.title
                    })
                  }, o.title);
                })
              }), l.extendedColumn && /* @__PURE__ */i(f, {
                children: [/* @__PURE__ */e(c, {
                  children: l.extendedColumn.columnName
                }), /* @__PURE__ */e(m, {
                  children: l.extendedColumn.links.map(function (o) {
                    return /* @__PURE__ */e(h, {
                      children: /* @__PURE__ */e(a, {
                        "aria-label": o.areaLabel,
                        href: o.href,
                        children: o.title
                      })
                    }, o.title);
                  })
                })]
              })]
            }, l.columnName);
          })
        }), /* @__PURE__ */i("div", {
          className: t.bottomContainer,
          children: [/* @__PURE__ */i(s, {
            variant: "body2",
            color: "#5E636B",
            className: t.copyright,
            children: ["© Copyright 2016 - ", k, " ", /* @__PURE__ */e(a, {
              href: "".concat(r, "/"),
              variant: "body2",
              children: "Mashvisor"
            }), ". All rights reserved"]
          }), /* @__PURE__ */i("div", {
            className: t.socialMedia,
            children: [/* @__PURE__ */e(a, {
              href: "https://www.facebook.com/Mashvisor/",
              target: "_blank",
              children: /* @__PURE__ */e(y, {})
            }), /* @__PURE__ */e(a, {
              href: "https://twitter.com/Mashvisor",
              target: "_blank",
              children: /* @__PURE__ */e(g, {})
            }), /* @__PURE__ */e(a, {
              href: "https://www.linkedin.com/company/mashvisor",
              target: "_blank",
              children: /* @__PURE__ */e(u, {})
            }), /* @__PURE__ */e(a, {
              href: "https://www.youtube.com/@Mashvisor",
              target: "_blank",
              children: /* @__PURE__ */e(b, {})
            }), /* @__PURE__ */e(a, {
              href: "https://www.instagram.com/mashvisorcom/",
              target: "_blank",
              children: /* @__PURE__ */e(N, {})
            })]
          }), /* @__PURE__ */e(p, {
            className: t.logo
          }), n === "homePage" && /* @__PURE__ */i("div", {
            className: t.bottomLinks,
            children: [/* @__PURE__ */e(a, {
              variant: "body2",
              href: "".concat(r, "/disclaimer"),
              children: "Terms & Conditions"
            }), /* @__PURE__ */e(a, {
              variant: "body2",
              href: "".concat(r, "/privacy-policy"),
              children: "Privacy Policy"
            }), /* @__PURE__ */e(a, {
              variant: "body2",
              href: "".concat(r, "/cookie-policy"),
              children: "Disclaimer"
            })]
          })]
        })]
      })
    });
  };
export { B as default };